import { boot } from '@dazn/bootstrap-lib';

import { Configuration } from '../global-modules';

const getResourceStringLinkOverrides = (
    config: Configuration,
    country: boot.config.AnyCountry,
    language: boot.config.Language,
) => {
    const overrides =
        config.resourceStringLinkOverrides[country]?.[language] || {};

    config.chapters.chapterList().forEach(chapterName => {
        const linkKey = config.chapters.linkKey(chapterName);
        if (!linkKey) {
            return;
        }
        const chapterUrl = config.chapters.homePage(chapterName);
        overrides[linkKey] = `/${chapterUrl}`;
    });
    return overrides;
};

export { getResourceStringLinkOverrides };
